import {
  MerchantDashboardWidgetColumnsSchema,
  MerchantDashboardWidgetSizeSchema,
} from "@redotech/redo-views-common/merchant-dashboards";
import { merchantDashboardIdFormat } from "@redotech/redo-warehouse-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  MerchantDashboardWidgetSchema,
  MerchantDashboardWidgetTitleSchema,
} from "./merchant-dashboard-fields";

export const addMerchantDashboardWidget = {
  name: "addMerchantDashboardWidget" as const,
  input: z.object({
    dashboardId: merchantDashboardIdFormat.schema,
    sourceViewId: zExt.objectId(),
    title: MerchantDashboardWidgetTitleSchema,
    size: MerchantDashboardWidgetSizeSchema.optional(),
    columns: MerchantDashboardWidgetColumnsSchema.optional(),
  }),
  output: z.object({ widget: MerchantDashboardWidgetSchema }),
};
